/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { user_data_sign_in_access } from './user_data_sign_in_access';
export type user_register = {
  status?: user_register.status;
  data: user_data_sign_in_access;
};
export namespace user_register {
  export enum status {
    SUCCESS = 'success',
    FAILURE = 'failure',
  }
}
